import { StyleSheet } from 'react-native';
import type { useTheme } from '../../hooks/useTheme';
import type { Selection } from '../../services/feedback/screenshot';

export const selectionStyle = (selection: Selection) => ({
  left: `${selection.x * 100}%` as `${number}%`, top: `${selection.y * 100}%` as `${number}%`,
  width: `${selection.width * 100}%` as `${number}%`, height: `${selection.height * 100}%` as `${number}%`,
});
export const imageStyle = (width: number, height: number) => ({ aspectRatio: width / height });
export const sheetInsets = (bottom: number) => ({ paddingBottom: Math.max(bottom, 16) });
export const makeStyles = (theme: ReturnType<typeof useTheme>) => StyleSheet.create({
  overlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.4)', justifyContent: 'flex-end' },
  sheet: { backgroundColor: theme.colors.card, borderRadius: 20, maxHeight: '90%', padding: 20, gap: 14 },
  row: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 12 },
  title: { fontSize: 20, fontWeight: '700', color: theme.colors.text },
  text: { fontSize: 14, lineHeight: 20, color: theme.colors.text },
  muted: { fontSize: 12, lineHeight: 18, color: theme.colors.muted },
  label: { fontSize: 14, fontWeight: '600', color: theme.colors.text, marginTop: 12, marginBottom: 8 },
  button: { paddingHorizontal: 12, paddingVertical: 12, borderRadius: 10, borderWidth: 1, borderColor: theme.colors.border, minHeight: 44, alignItems: 'center', justifyContent: 'center' },
  selected: { borderColor: theme.colors.primary, backgroundColor: `${theme.colors.primary}15` },
  primary: { backgroundColor: theme.colors.primary, borderColor: theme.colors.primary },
  primaryText: { fontSize: 15, fontWeight: '600', color: '#fff' },
  disabled: { opacity: 0.45 },
  input: { borderWidth: 1, borderColor: theme.colors.border, borderRadius: 10, padding: 12, minHeight: 110, color: theme.colors.text, fontSize: 15, textAlignVertical: 'top' },
  error: { color: theme.colors.error, fontSize: 14, marginTop: 8 },
  preview: { width: '100%', position: 'relative', marginTop: 12, overflow: 'hidden', borderRadius: 8, borderWidth: 1, borderColor: theme.colors.border },
  image: { width: '100%', height: '100%' },
  selection: { position: 'absolute', borderWidth: 3, borderColor: '#e02020', backgroundColor: 'rgba(224,32,32,0.08)' },
  prompt: { padding: 14, marginVertical: 12, borderRadius: 12, borderWidth: 1, borderColor: theme.colors.border, backgroundColor: theme.colors.card, gap: 10 },
  entry: { padding: 8, minHeight: 44, justifyContent: 'center', alignItems: 'center' },
  entryText: { fontSize: 12, color: theme.colors.muted },
  stars: { color: theme.colors.primary, fontSize: 25 },
});
